import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { startSignIn } from '../auth/start-sign-in';
import { isAuthBypassed } from '../auth/auth-bypass';

/**
 * Signed in, whatever the role — the gate of the "page not found" route under /extranet (WI 3787).
 *
 * An unknown address inside the app renders in the shell, so a signed-out visitor goes through the
 * B2C sign-in first and comes back to the address they typed (WI 3861's return URL), where they
 * see the not-found page with their own navigation — instead of the old silent redirect to Home.
 * No GET /me here: the page shows no data, and the role-specific guards on the real pages keep
 * doing the role checks. Locally (`isAuthBypassed`) there is no MSAL account to find.
 */
export const signedInGuard: CanActivateFn = (_route, state) => {
  const msal = inject(MsalService);
  const router = inject(Router);
  if (isAuthBypassed() || msal.instance.getActiveAccount()) return true;
  return startSignIn(msal, router, state.url);
};
